import { EOfficeType, Filters } from 'shared/types/filters';

export function hasWorkplaceOfficeType(filters: Filters): boolean {
  return filters.officeType.includes(EOfficeType.Workplace);
}
